import { Component, OnInit } from '@angular/core';
import { HelperService } from '../../../Services/helper.service';
import { MainService } from '../../../Services/main.service';
import { Category } from '../../../models/category';
import { CategoryService } from '../../../Services/category.service';
import { TranslationService } from '../../../Services/translation.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CategoriesModalService } from '../../categories-modal';
import {CITY} from "../../../tokens";

@Component({
  selector: 'categories-nav',
  templateUrl: './categories-nav.component.html',
  styleUrls: ['./categories-nav.component.css'],
})
export class CategoriesNavComponent implements OnInit {
  categories: Category[] = [];
  categoriesList: any;
  currentCity: string;
  word: any = {};
  language: string = '';
  insidePageCheck: boolean;
  hideCategory: boolean = true;

  allowedCategories: object = {
    sofia: [9, 16, 26, 10, 177, 14, 340, 24],
    plovdiv: [5, 11, 8, 1, 155, 7, 119, 9],
    varna: [9, 26, 14, 16, 10, 147, 136, 115],
    burgas: [9, 16, 26, 10, 87, 134, 14, 201],
    tarnovo: [9, 16, 26, 10, 118, 24, 107, 21, 25],
    bansko: [9, 16, 26, 87, 10],
    skopje: [9, 16, 26, 10, 177, 14, 340, 24],
    beograd: [9, 16, 26, 10, 177, 14, 340, 24],
  };

  categoriesStyles: object = {
    sofia: {
      9: 'fa fa-cutlery',
      16: 'fa fa-ticket',
      26: 'fa fa-ticket',
      10: 'fa fa-glass',
      177: 'fa fa-cutlery',
      14: 'ic-moon icon-pizza',
      340: 'fa fa-child',
      24: 'fa fa-beer',
    },
    plovdiv: {
      5: 'fa fa-cutlery',
      11: 'fa fa-ticket',
      8: 'ic-moon icon-taverns',
      1: 'fa fa-coffee',
      155: 'fa fa-folder',
      7: 'ic-moon icon-pizza',
      119: 'fa fa-glass',
      9: 'fa fa-beer',
    },
    varna: {
      9: 'fa fa-cutlery',
      26: 'ic-moon icon-taverns',
      14: 'ic-moon icon-pizza',
      16: 'fa fa-ticket',
      10: 'fa fa-glass',
      147: 'fa fa-microphone',
      136: 'fa fa-folder',
      115: 'fa fa-folder',
    },
    burgas: {
      9: 'fa fa-cutlery',
      16: 'fa fa-ticket',
      26: 'ic-moon icon-taverns',
      10: 'fa fa-glass',
      87: 'fa fa-coffee',
      134: 'fa fa-folder',
      14: 'ic-moon icon-pizza',
      201: 'fa fa-folder',
    },
    tarnovo: {
      9: 'fa fa-cutlery',
      16: 'fa fa-ticket',
      26: 'ic-moon icon-taverns',
      10: 'fa fa-glass',
      118: '',
      24: 'fa fa-cutlery',
      107: '',
      21: '',
      25: '',
    },
    bansko: {
      9: 'fa fa-cutlery',
      16: 'fa fa-ticket',
      26: 'ic-moon icon-taverns',
      87: 'fa fa-coffee',
      10: 'fa fa-glass',
    },
    skopje: {
      9: 'fa fa-cutlery',
      16: 'fa fa-ticket',
      26: 'ic-moon icon-taverns',
      10: 'fa fa-glass',
      177: 'fa fa-cutlery',
      14: 'ic-moon icon-pizza',
      340: 'fa fa-child',
      24: 'fa fa-beer',
    },
    beograd: {
      9: 'fa fa-cutlery',
      16: 'fa fa-ticket',
      26: 'ic-moon icon-taverns',
      10: 'fa fa-glass',
      177: 'fa fa-cutlery',
      14: 'ic-moon icon-pizza',
      340: 'fa fa-child',
      24: 'fa fa-beer',
    },
  };

  constructor(
    public router: Router,
    private activatedRoute: ActivatedRoute,
    private helperService: HelperService,
    private mainService: MainService,
    private categoryService: CategoryService,
    private translationService: TranslationService,
    private modalService: CategoriesModalService,
    @Inject(PLATFORM_ID) private platformId,
    @Inject(CITY) private injectedCity: string
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.word = this.translationService.word;
      this.language = this.translationService.language;
      this.router.routeReuseStrategy.shouldReuseRoute = function () {
        return false;
      };

      this.word = this.translationService.word;
      this.language = this.translationService.language;

      this.insidePageCheck = this.router.url == '/' || this.router.url == '/en';
      this.hideCategory = this.currentCity == 'sofia' && this.insidePageCheck;
    }
  }

  ngOnInit(): void {
    this.translationService.getLang().subscribe((value) => {
      this.categoryService.getAll().subscribe((x) => {
        const city = this.injectedCity || this.helperService.getCity();
        this.currentCity = city;
        this.categories = x.filter((y) =>
          this.allowedCategories[city].includes(y?.id)
        );
      });
      this.mainService.getCriterias().subscribe((result) => {
        this.categoriesList = result.response;
      });
    });
  }
  openModal(id: string) {
    this.modalService.open(id);
  }
  closeModal(id: string) {
    this.modalService.close(id);
  }
  ngAfterContentChecked() {
    this.insidePageCheck = this.router.url == '/' || this.router.url == '/en';
    this.hideCategory = this.currentCity == 'sofia' && this.insidePageCheck;
  }
}
